import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { UserContextType } from "tht-impianti-cl";

export interface UserProfile {
  userId?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  avatarImage?: string | null;
}

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
  imports: [CommonModule]
})
export class UserProfileComponent {
  @Input() user: UserProfile | null = {};
  @Input() showToggle: boolean = false;
  @Input() contextType: UserContextType | undefined = undefined;
  @Output() toggleSidebar = new EventEmitter<void>();

  protected getBorderByContext() {
    if (!this.contextType) return undefined;
    switch (this.contextType) {
      case "CLIENT": return "2px solid rgb(230, 85, 23)";
      case "SUPPLIER": return "2px solid rgb(0, 72, 217)";
      case "SUPERVISOR": return "2px solid rgb(176, 218, 146)";
    }
  }

  get displayName(): string | null {
    if (!this.user) return null;
    
    if (this.user.firstName && this.user.lastName) {
      return `${this.user.firstName} ${this.user.lastName}`;
    } else if (this.user.firstName) {
      return this.user.firstName;
    } else if (this.user.lastName) {
      return this.user.lastName;
    }
    return null;
  }

  get avatarInitial(): string | null {
    if (!this.user) return "-";
    
    if (this.user.firstName) {
      return this.user.firstName.charAt(0).toUpperCase();
    } else if (this.user.lastName) {
      return this.user.lastName.charAt(0).toUpperCase();
    }
    return null;
  }

  get hasAvatar(): boolean {
    return !!(this.user?.avatarImage);
  }

  onToggleClick(): void {
    this.toggleSidebar.emit();
  }
} 